export default function (matchLength: string): number {
  return matchLength === '2*45' ? 15 : 5;
}
